var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconEtherium = function SvgIconEtherium(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 24,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 23,
    x: 0.5,
    y: 0.5,
    fill: "#fff",
    stroke: "#fff",
    rx: 3.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#IconEtherium_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EFB914",
    d: "M18 20a8 8 0 0 1-8-8 8 8 0 0 1 8-8 8 8 0 0 1 8 8 8 8 0 0 1-8 8m2.501-11.072.405-1.621-1.298-.323-.322 1.287a4 4 0 0 0-.649-.161l.322-1.287-1.297-.323-.405 1.62c-1.492.272-2.755 1.369-3.14 2.912s.212 3.103 1.401 4.04l-.405 1.621 1.299.323.321-1.287q.319.106.649.161l-.322 1.287 1.298.323.405-1.62a3.99 3.99 0 0 0 2.6-1.693l-1.424-.354a2.69 2.69 0 0 1-2.567.715c-1.432-.356-2.31-1.786-1.958-3.193.351-1.408 1.8-2.26 3.233-1.904a2.68 2.68 0 0 1 1.93 1.834l1.423.354a3.97 3.97 0 0 0-1.499-2.711"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "IconEtherium_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10 4h16v16H10z"
  })))));
};
export default SvgIconEtherium;